import React from "react";

export default function Footer() {
  return (
    <div className="bg-[#04177f] flex justify-center items-center text-[#fff] text-[14px] h-[83px] md:text-[16px] md:h-[83px] lg:h-[98px]">
      ©AremxyPlug 2023. All Rights Reserved.
    </div>
  );
}
